import logger from './logger';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl  = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey  = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  logger.warn('Supabase env vars missing — check your .env file');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: false,   // no localStorage auth session needed
    autoRefreshToken: false, // no token refresh needed
    detectSessionInUrl: false,
  },
  realtime: {
    params: { eventsPerSecond: 0 }, // disable realtime subscriptions
  },
  global: {
    headers: { 'x-application-name': 'hattrickgrid' },
  },
});

// Auth helpers removed — not currently used (user auth is a future feature)
